export default __webpack_public_path__ + "static/media/pass_word_bg.49fc7cd9.png";